import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AxiosError } from 'axios';
import config from '../config';
import TextareaAutosize from 'react-textarea-autosize';
import LocationSelector from './LocationSelector';
import Groups, { Group } from './Groups';
import './SendMessageButton.css'; // Import the CSS file

const SendMessageButton: React.FC<{ selectedGroups: Group[] }> = ({ selectedGroups }) => {
    const [phoneNumbers, setPhoneNumbers] = useState<string[]>([]);

    // Update phoneNumbers state when selectedGroups changes
    useEffect(() => {
        const newPhoneNumbers = selectedGroups.flatMap(group => group.contacts.map(contact => contact.phoneNumber));
        setPhoneNumbers(Array.from(new Set(newPhoneNumbers)));
    }, [selectedGroups]);

    const [location, setLocation] = useState('{search a place to replace this text}');
    //const [message, setMessage] = useState('Hello, this is a test message from RoundUp! Sohrab is letting you know he is playing basketball today,7/14/23 at 5:00 AM at proclub located at 4455 148th Ave NE, Bellevue, WA 98007 . Text him back at 4255058230 if you would like to join! (Is this annoying or something you could see as a useful tool? There will be options to unsubscribe and repond back directly to the text message instead of texting me directly to let the person know if you can make it or not. Would love any feedback that you have that you can text to my number at 4255058230.)');

    // Get the current date and time
    const now = new Date();
    const dateStr = `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
    const timeStr = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

    // Get the timezone
    const timeZone = /\((.*)\)/.exec(new Date().toString())?.[1] || '';

    const [message, setMessage] = useState(`Hello, your friend is using Round Up (www.roundup.events) to let you know that they are playing basketball on ${dateStr} at ${timeStr} ${timeZone} at ${location}. Join if you can!`);

    const handleLocationSelect = (newLocation: string) => {
        setLocation(newLocation);
        setMessage(`Hello, your friend is using Round Up (www.roundup.events) to let you know that they are playing basketball on ${dateStr} at ${timeStr} ${timeZone} at ${newLocation}. Join if you can!`);
    };

    const sendMessage = async () => {
        try {
            await axios.post(`${config.apiUrl}/send-text`, { to: phoneNumbers, body: message });
            alert('Message sent!');
        } catch (err) {
            const error = err as AxiosError;
            console.error('Failed to send message:', error.response?.data);
            alert('Failed to send message');
        }
    };

    const clearPhoneNumbers = () => {
        setPhoneNumbers([]);
    };

    return (
        <div className="sendMessageButton">
            <LocationSelector onLocationSelect={handleLocationSelect} /> 
            <h3>Send Message:</h3>
            <p>Please customize your message as you see fit:</p>
            <TextareaAutosize value={message} onChange={(e) => setMessage(e.target.value)} placeholder='Message' />
            <button onClick={sendMessage}>Send Message</button>
        </div>
    );
};

export default SendMessageButton;
/* Commented out To phone Numbers Input

<p> This will fill automatically with numbers from the selected groups. You can also type a number in the internation format: +(Countrty Code)(Area Code)(4 Digits Number). An example for USA Numbers: +12064534589. Please seperate mulitple numbers with a comma.</p>
            <div>
            <p>To Phone Numbers:</p>
                <input type='text' value={phoneNumbers.join(',')} onChange={(e) => setPhoneNumbers(e.target.value.split(',').map(phoneNumber => phoneNumber.trim()))} placeholder='Phone Numbers' />
            </div>
            <button onClick={clearPhoneNumbers}>Clear</button>*/